export const getAudience = (): string => {
  switch (process.env.GATSBY_REGION_REGION_DIFFERENTIATOR.replace(' DEV', '')) {
    case 'EU B2C':
    case 'UK B2C':
      return 'eu';
    case 'EU B2B':
      return 'eu_pro';
    case 'US B2C':
      return 'us';
    case 'US B2B':
      return 'us_pro';
    case 'UK B2B':
      return 'uk_pro';
    case 'CA B2C':
      return 'canada';
  }
};
